import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { RouterProvider } from 'react-router-dom';

import { router } from './routes/_root/router';
import { ThemeProvider } from './providers/ThemeProvider';
import { AuthProvider } from './providers/AuthProvider';
import { EventProvider } from './providers/EventProvider';
import { PDFViewerProvider } from './providers/PDFViewerProvider';
import { EventStreamProvider } from './providers/EventStreamProvider';
import { useVersion } from './hooks';

const queryClient = new QueryClient();

function AppContent() {
  useVersion();

  return (
    <>
      <Notifications />
      <RouterProvider router={router} />
    </>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <ModalsProvider>
          <AuthProvider>
            <EventStreamProvider>
              <EventProvider>
                <PDFViewerProvider>
                  <AppContent />
                </PDFViewerProvider>
              </EventProvider>
            </EventStreamProvider>
          </AuthProvider>
        </ModalsProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
